module.exports = __webpack_public_path__ + "img/cart-shortcut.321cea49.svg";